import { CheckBoxFieldTheme } from './CheckBoxField.types';
import merge from 'deepmerge';

export const defaultCheckBoxTheme: CheckBoxFieldTheme = {};

export const createCheckBoxTheme = (
  customTheme: CheckBoxFieldTheme = {
    checkBoxWrapper: {
      style: {
        alignItems: 'center',
      },
    },
    checkBoxInput: {
      style: {
        borderRadius: '.4rem',
      },
    },
  },
): CheckBoxFieldTheme => merge(defaultCheckBoxTheme, customTheme);
